import { render, staticRenderFns } from "./supplierContractDetail.vue?vue&type=template&id=04f0cfd2"
import script from "./supplierContractDetail.vue?vue&type=script&lang=js"
export * from "./supplierContractDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports